export default __webpack_public_path__ + "static/media/willCostsBeCovered_lg_woman.f56ef07c.png";